import { render, staticRenderFns } from "./Patiens.vue?vue&type=template&id=49d708c4&scoped=true"
import script from "./Patiens.vue?vue&type=script&lang=js"
export * from "./Patiens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d708c4",
  null
  
)

export default component.exports